import React, { FC } from "react";

type SvgProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<SvgProps> = ({ width = 14, height = 13 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      // eslint-disable-next-line max-len
      d="M15.1654 4.72363L9.18536 8.52363C8.97955 8.65258 8.74158 8.72097 8.4987 8.72097C8.25582 8.72097 8.01785 8.65258 7.81203 8.52363L1.83203 4.72363M3.16536 2.72363H13.832C14.5684 2.72363 15.1654 3.32059 15.1654 4.05697V12.057C15.1654 12.7933 14.5684 13.3903 13.832 13.3903H3.16536C2.42898 13.3903 1.83203 12.7933 1.83203 12.057V4.05697C1.83203 3.32059 2.42898 2.72363 3.16536 2.72363Z"
      stroke="#262626"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgComponent;
